<template>
  <BaseBlock title="Recevabilité des demandes">
    <v-container>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Filtres de recherche
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row align="center">
              <v-col cols="2">
                <v-text-field
                  v-model="search.etablissement"
                  label="établissement"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="search.demandeur"
                  label="demandeur"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="search.brouillon"
                  label="voir les brouillons"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <SearchDateWidget
              :searchOnDate="search.searchOnDate"
              v-on:update:searchOnDate="search.searchOnDate = $event"
              :dateMin="search.dateMin"
              v-on:update:dateMin="search.dateMin = $event"
              :dateMax="search.dateMax"
              v-on:update:dateMax="search.dateMax = $event"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        :headers="headers"
        :items="dossiersExamenAdministratif"
        v-if="dossiers"
      >
        <!-- template du header "voir" -->
        <template v-slot:[`header.dossier`]="{}">
          <v-icon>mdi-eye</v-icon>
        </template>
        <!-- template des cellules "voir" -->
        <template v-slot:[`item.dossier`]="{ item }">
          <LinkToPDFWidget :dossier="item" />
        </template>
        <!-- template des cellules "établissement" -->
        <template v-slot:[`item.officine.denomination`]="{ item }">
          <div class="text-body-2">{{ item.officine.denomination }}</div>
          <div class="text-caption grey--text font-italic">
            {{ item.officine.codePostal }}
            -
            {{ item.officine.ville }}
          </div>
        </template>
        <!-- template des cellules "demandeur" -->
        <template v-slot:[`item.demandeur`]="{ item }">
          <div class="text-body-2">{{ item.demandeur }}</div>
          <div class="text-caption grey--text font-italic">
            <a
              target="_blank"
              :href="
                `mailto:${item.contactMail}?subject=Pharmagrément - Suivi du dossier de demande d'agrément de: ${item.officine.denomination}`
              "
            >
              {{ item.contactMail }}
            </a>
          </div>
        </template>
        <!-- template des cellules "type" -->
        <template v-slot:[`item.premiereDemande`]="{ item }">
          <div class="text-body-2">
            {{ item.premiereDemande ? "Première demande" : "Renouvellement" }}
          </div>
        </template>
        <!-- template des cellules "date" -->
        <template v-slot:[`item.dateDepot`]="{ item }">
          <div class="text-body-2" v-if="isBrouillon(item)">
            Brouillon<span v-if="'01/01/1970' !== getDate(item.dateDepot)">
              ({{ getDate(item.dateDepot) }})</span
            >
          </div>
          <div class="text-body-2" v-else>{{ getDate(item.dateDepot) }}</div>
        </template>
        <!-- template des cellules "actions" -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-center">
            <div>
              <v-btn
                @click="approuver(item)"
                :disabled="isBrouillon(item)"
                x-small
              >
                approuver
              </v-btn>
            </div>
            <div>
              <v-btn
                @click="openDemandeModificationDialog(item)"
                :disabled="isBrouillon(item)"
                x-small
              >
                demander une modification
              </v-btn>
            </div>
            <div>
              <v-btn @click="envoyerMailInscription(item)" x-small>
                renvoyer le code
              </v-btn>
            </div>
            <div>
              <v-btn @click="supprimer(item)" x-small>
                supprimer
              </v-btn>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-container>
    <!-- popup demande de modification -->
    <ModalDemandeModification
      :dossier="currentDossier"
      :display="modalDemandeModificationDisplay"
      v-on:update:display="modalDemandeModificationDisplay = $event"
      v-on:ModalDemandeModificationAction="demandeModification($event)"
      v-if="modalDemandeModificationDisplay"
    />
  </BaseBlock>
</template>

<script>
import { mapState } from "vuex";
import common from "@/common";
import BaseBlock from "@/components/base/BaseBlock";
import LinkToPDFWidget from "@/components/LinkToPDFWidget";
import SearchDateWidget from "@/components/SearchDateWidget";
import ModalDemandeModification from "@/components/ModalDemandeModification";

export default {
  name: "RecevabiliteDesDemandes",
  components: {
    BaseBlock,
    LinkToPDFWidget,

    ModalDemandeModification,
    SearchDateWidget
  },
  data() {
    return {
      refresh_dossier_timer: null,
      modalDemandeModificationDisplay: false,
      currentDossier: null,
      search: {
        etablissement: "",
        demandeur: "",
        brouillon: false,
        searchOnDate: false,
        dateMin: null,
        dateMax: null
      },
      headers: [
        {
          align: "center",
          sortable: false,
          value: "dossier"
        },
        {
          text: "Etablissement",
          align: "start",
          sortable: true,
          value: "officine.denomination"
        },
        {
          text: "Demandeur",
          align: "start",
          sortable: true,
          value: "demandeur"
        },
        {
          text: "Type",
          align: "start",
          sortable: true,
          value: "premiereDemande"
        },
        {
          text: "Date de dépot de la demande",
          align: "start",
          sortable: true,
          value: "dateDepot"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  computed: {
    ...mapState(["dossiers", "user"]),
    dossiersExamenAdministratif() {
      return this.dossiers
        .filter(d => {
          if ("" !== this.search.etablissement) {
            if (
              !d.officine ||
              !d.officine.denomination
                .toLowerCase()
                .includes(this.search.etablissement)
            )
              return false;
          }
          if ("" !== this.search.demandeur) {
            if (!d.contactPrenom || !d.contactNom) return false;
            if (
              !(d.contactPrenom + " " + d.contactNom)
                .toLowerCase()
                .includes(this.search.demandeur)
            )
              return false;
          }
          if (
            this.search.searchOnDate &&
            !common.matchDate(d, this.search.dateMin, this.search.dateMax)
          )
            return false;
          if (true === this.search.brouillon && common.isBrouillon(d))
            return true;
          return common.isExamenAdministratif(d);
        })
        .map(d => {
          d.demandeur = d.contactPrenom + " " + d.contactNom;
          return d;
        });
    }
  },
  async created() {
    if (null === this.dossiers) await this.loadDossiers();
    else this.loadDossiers();
    this.refresh_dossier_timer = setInterval(
      this.loadDossiers,
      common.REFRESH_TIMER
    );
  },
  beforeDestroy() {
    clearInterval(this.refresh_dossier_timer);
  },
  methods: {
    async loadDossiers() {
      this.$store.dispatch("loadDossiers");
    },
    getDate(timestamp) {
      return common.formatDate(timestamp);
    },
    isBrouillon(dossier) {
      return common.isBrouillon(dossier);
    },
    async approuver(dossier) {
      dossier = await common.setEtatAttente(dossier);
      this.$store.dispatch("updateDossier", dossier);
      this.$toast.success("Le dossier a été approuvé.");
    },
    openDemandeModificationDialog(dossier) {
      this.currentDossier = dossier;
      this.modalDemandeModificationDisplay = true;
    },
    async demandeModification(dialogData) {
      const dossier = await common.setEtatBrouillon(dialogData.dossier, {
        motif: dialogData.motif
      });
      this.$store.dispatch("updateDossier", dossier);
      this.$toast.success(
        "Une demande de modification du dossier a été envoyée."
      );
    },
    envoyerMailInscription(dossier) {
      common.sendMailInscription(dossier);
      this.$toast.success("Le code a été renvoyé.");
    },
    async supprimer(dossier) {
      const confirmation = await this.$confirm(
        "<b>Voulez-vous supprimer ce dossier ?</b><br/>Cette action est irréversible."
      );
      if (confirmation) {
        await common.deleteDossier(dossier);
        this.$store.dispatch("removeDossier", dossier);
        this.$toast.success("Le dossier a été supprimé.");
      }
    }
  }
};
</script>
